import { TableUI } from "components/design/TableUI";
import {
  createColumnHelper,
  getCoreRowModel,
  useReactTable,
} from "react-table-8.10.7";
import { ParsedListForBulkCart } from "types/Models/serviceTeam";
import { ClampedTextWithTooltip } from "utils/ClampedTextWithTooltip";

const createColumn = createColumnHelper<ParsedListForBulkCart>();

const columns = [
  createColumn.accessor("company_name", {
    header: "GROUP",
    size: 50,
    cell: (info) => (
      <ClampedTextWithTooltip
        text={info.getValue()}
        lineClampElementClass="t-line-clamp-1 t-text-body-sm t-text-text-60"
        toolTipClass="t-w-64 t-word-break !t-text-left"
      />
    ),
  }),
  createColumn.accessor("entity_name", {
    header: "ENTITY",
    size: 50,
    cell: (info) => (
      <ClampedTextWithTooltip
        text={info.getValue()}
        lineClampElementClass="t-line-clamp-1 t-text-body-sm t-text-text-60"
        toolTipClass="t-w-64 t-word-break !t-text-left"
      />
    ),
  }),
];

export const BulkActionCsvTable = ({
  list,
}: {
  list: ParsedListForBulkCart[];
}) => {
  const table = useReactTable({
    data: list,
    columns: columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return <TableUI table={table} size="regular" height="240px" />;
};
